import styled from "styled-components";
import useVariation from "../../hooks/useVariation";
import CartProduct from "../../store/cart-product/model";
import LedgerItems from "../checkout/LedgerItems";
import MagicFade, { FadeStyles } from "../MagicFade";
import FlyoutCartEmpty from "./FlyoutCartEmpty";
import FlyoutCartQuizEntry from "./FlyoutCartQuizEntry";

const ProductsWrapper = styled.div`
  ${FadeStyles}

  &:has(.vertical-center) {
    display: flex;
    height: 100%;
    align-items: center;
  }
`;

export default function CartItemList({
  cartProducts,
  isProcessing,
  cartQuantity,
}: {
  cartProducts: CartProduct[];
  isProcessing: boolean;
  cartQuantity: number;
}) {
  const quizEntry = useVariation("quiz-entry-empty-cart-flyout", false);

  const showLedger = !!cartQuantity;
  const showQuizEntry = quizEntry && !showLedger;
  const showEmpty = !showLedger && !showQuizEntry;

  return (
    <ProductsWrapper>
      <MagicFade transitionKey={!!cartQuantity}>
        <>
          {showEmpty && <FlyoutCartEmpty />}
          {showQuizEntry && <FlyoutCartQuizEntry />}
          {showLedger && (
            <LedgerItems
              activeCartProducts={cartProducts}
              disableAnimation={true}
              isProcessing={isProcessing}
              cartItemOptions={{
                hideDeleteButton: false,
                disableQuantitySelector: false,
              }}
            />
          )}
        </>
      </MagicFade>
    </ProductsWrapper>
  );
}
